import { render, staticRenderFns } from "./order-pre-list-by-id.vue?vue&type=template&id=990c7194&scoped=true&"
import script from "./order-pre-list-by-id.vue?vue&type=script&lang=js&"
export * from "./order-pre-list-by-id.vue?vue&type=script&lang=js&"
import style0 from "./order-pre-list-by-id.vue?vue&type=style&index=0&id=990c7194&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990c7194",
  null
  
)

export default component.exports